/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { License } from './License';
import {
    LicenseFromJSON,
    LicenseFromJSONTyped,
    LicenseToJSON,
    LicenseToJSONTyped,
} from './License';

/**
 * 
 * @export
 * @interface SubmissionRequest
 */
export interface SubmissionRequest {
    /**
     * 
     * @type {string}
     * @memberof SubmissionRequest
     */
    protein: string;
    /**
     * 
     * @type {number}
     * @memberof SubmissionRequest
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof SubmissionRequest
     */
    targetAA: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionRequest
     */
    vinaJobDesiredRun?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionRequest
     */
    reuseUnfinishedJob?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionRequest
     */
    requireTemplateId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionRequest
     */
    preventStart?: boolean;
    /**
     * 
     * @type {License}
     * @memberof SubmissionRequest
     */
    license?: License;
}

/**
 * Check if a given object implements the SubmissionRequest interface.
 */
export function instanceOfSubmissionRequest(value: object): value is SubmissionRequest {
    if (!('protein' in value) || value['protein'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('targetAA' in value) || value['targetAA'] === undefined) return false;
    return true;
}

export function SubmissionRequestFromJSON(json: any): SubmissionRequest {
    return SubmissionRequestFromJSONTyped(json, false);
}

export function SubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'protein': json['protein'],
        'position': json['position'],
        'targetAA': json['targetAA'],
        'vinaJobDesiredRun': json['vinaJobDesiredRun'] == null ? undefined : json['vinaJobDesiredRun'],
        'reuseUnfinishedJob': json['reuseUnfinishedJob'] == null ? undefined : json['reuseUnfinishedJob'],
        'requireTemplateId': json['requireTemplateId'] == null ? undefined : json['requireTemplateId'],
        'preventStart': json['preventStart'] == null ? undefined : json['preventStart'],
        'license': json['license'] == null ? undefined : LicenseFromJSON(json['license']),
    };
}

export function SubmissionRequestToJSON(json: any): SubmissionRequest {
    return SubmissionRequestToJSONTyped(json, false);
}

export function SubmissionRequestToJSONTyped(value?: SubmissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'protein': value['protein'],
        'position': value['position'],
        'targetAA': value['targetAA'],
        'vinaJobDesiredRun': value['vinaJobDesiredRun'],
        'reuseUnfinishedJob': value['reuseUnfinishedJob'],
        'requireTemplateId': value['requireTemplateId'],
        'preventStart': value['preventStart'],
        'license': LicenseToJSON(value['license']),
    };
}

